import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import PropTypes from "prop-types";
import Papa from "papaparse";

import ButtonV1 from "components/ButtonV1";
import { downloadCsv } from "utils";

const SampleDataModal = ({
  open,
  onClose,
  title = "Sample Data",
  headers = [],
  sampleData = [],
  fileName = "sample_data",
}) => {
  const handleDownloadSample = () => {
    if (!sampleData.length && !headers.length) return;
    const csvContent = Papa.unparse(sampleData);
    downloadCsv(csvContent, fileName);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Typography variant="h6" fontWeight={700}>
          {title}
        </Typography>
        <IconButton size="small" onClick={onClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Typography fontSize={13} color="text.secondary" mb={2}>
          Below is a preview of the expected format and valid sample values for this table.
        </Typography>

        <TableContainer sx={{ maxHeight: 420, border: "1px solid #E5E7EB", borderRadius: "8px" }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {headers.map((header) => (
                  <TableCell
                    key={header}
                    sx={{
                      backgroundColor: "#F9FAFB",
                      fontWeight: 700,
                      fontFamily: "monospace",
                      fontSize: 12,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {header}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {sampleData.map((row, rIndex) => (
                <TableRow key={rIndex} hover>
                  {headers.map((header) => (
                    <TableCell
                      key={header}
                      sx={{
                        fontFamily: "monospace",
                        fontSize: 12,
                        whiteSpace: "nowrap",
                      }}
                    >
                      {String(row[header] ?? "-")}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, justifyContent: "space-between" }}>
        <ButtonV1
          title="Download Sample CSV"
          onClick={handleDownloadSample}
          startIcon={<DownloadIcon fontSize="small" />}
          variant="outlined"
          size="small"
        />
        <ButtonV1 title="Close" onClick={onClose} size="small" />
      </DialogActions>
    </Dialog>
  );
};

SampleDataModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  headers: PropTypes.arrayOf(PropTypes.string),
  sampleData: PropTypes.arrayOf(PropTypes.object),
  fileName: PropTypes.string,
};

export default SampleDataModal;
